const endpoint = "https://rvpb2.cuba-lv.com"
const cpoint = "https://central-backend.cuba-lv.com"
const mediapoint = cpoint

const gamePlace = { studio: "tbilisi", room: "po4-room" } // tbilisi, bishkek
const name = "Vip Russian Poker"
const number = 2

export { endpoint, cpoint, mediapoint, gamePlace, name, number }
